/**
 * Conversion goal shared by the In-App designer and the Reminder editor (D10).
 * Wire shape (RRS docs/reminders-stats-summary.md "Reminder goal", same as In-App):
 *   { event: "<event name>", attribution_window: { value, unit: minutes|hours|days }, conditions: [...] }
 * `event` is the event NAME — Event's window funnel matches `event = goal_event`.
 * The Conversion Events list (GET /event-conversations) gives {id, name}; an In-App message saved
 * before DA-BUG-0691 holds the row id, which goalEventName() maps back to the name.
 */
const UNITS = ['minutes', 'hours', 'days'];

export const blankGoalForm = () => ({ enabled: false, event: '', conditions: [], window: 24, windowUnit: 'hours' });

export function goalEventName(value, conversionEvents = []) {
  const v = value == null ? '' : String(value).trim();
  if (!v) return '';
  const byId = (conversionEvents || []).find((e) => e && e.id === v);
  return byId ? byId.name : v;
}

export function goalFormFromApi(goal, conversionEvents = []) {
  if (!goal || typeof goal !== 'object' || !goal.event) return blankGoalForm();
  const w = goal.attribution_window || {};
  const value = Number(w.value);
  return {
    enabled: true,
    event: goalEventName(goal.event, conversionEvents),
    conditions: Array.isArray(goal.conditions) ? goal.conditions : [],
    window: Number.isFinite(value) && value > 0 ? value : 24,
    windowUnit: UNITS.includes(w.unit) ? w.unit : 'hours',
  };
}

// null clears the stored goal (PUT /reminders: null or {} clears, omitted keeps).
export function goalToApi(form) {
  const event = form && form.enabled ? String(form.event || '').trim() : '';
  if (!event) return null;
  const value = Number(form.window);
  const ok = Number.isInteger(value) && value > 0 && UNITS.includes(form.windowUnit);
  return {
    event,
    attribution_window: ok ? { value, unit: form.windowUnit } : { value: 24, unit: 'hours' },
    conditions: (form.conditions || []).filter((c) => c && String(c.property || '').trim()),
  };
}

// Options for the goal-event dropdown: Conversion Events first, then the tenant's other events.
export function goalEventOptions(conversionEvents = [], otherEvents = [], current = '') {
  const seen = new Set();
  const out = [];
  const add = (name, group) => { const n = String(name || '').trim(); if (n && !seen.has(n)) { seen.add(n); out.push({ value: n, label: n, group }); } };
  (conversionEvents || []).forEach((e) => add(e && e.name, 'Conversion events'));
  (otherEvents || []).forEach((e) => add(e, 'Other events'));
  if (current) add(current, 'Saved');
  return out;
}
